module.exports = __webpack_public_path__ + "static/media/raceGameConcepts_02.c9662a6f.jpg";